import { useQueryClient } from "@tanstack/react-query";
import { Cliente } from "../../../../services/Cliente";

export const useClienteLista = () => {
  const queryClient = useQueryClient();

  const buscarClientes = (nomeCpfCnpj: string) => {
    return queryClient
      .fetchQuery({
        queryKey: ["cliente-lista", nomeCpfCnpj],
        queryFn: () => Cliente.lista({ nomeCpfCnpj, page: 0, size: 5 }),
      })
      .then(({ data }) => data);
  };

  return { buscarClientes };
};
